<template>
  <div class="block">
    <slot></slot>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
@import '~style/variables';

.block {
  background: #fff;
  box-shadow: $s-md;
  border-radius: $r;
  margin-bottom: 1.5rem;
  // block already has a border around it
  > .table {
    border: none;
  }
  > .foot {
    border-top: 1px solid $c-border;
    font-size: $h65;
    font-weight: $medium;
    padding: 0.5rem 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/globals/Block.vue